// acciones
export const SAGA_SET_DIAS_ADELANTE_TURNERO = 'configuracionesReducer/SAGA_SET_DIAS_ADELANTE_TURNERO'
export const SAGA_GET_CALENDARIOS_TURNERO = 'configuracionesReducer/SAGA_GET_CALENDARIOS_TURNERO'
export const SET_CALENDARIOS_TURNERO = 'configuracionesReducer/SET_CALENDARIOS_TURNERO'

export const SAGA_ELIMINAR_CALENDARIO_HORARIO = 'configuracionesReducer/SAGA_ELIMINAR_CALENDARIO_HORARIO'
export const SAVE_CALENDARIO_HORARIO = 'configuracionesReducer/SAVE_CALENDARIO_HORARIO'

export const SAGA_ELIMINAR_CALENDARIO_NO_LABORABLE = 'configuracionesReducer/SAGA_ELIMINAR_CALENDARIO_NO_LABORABLE'
export const SAVE_CALENDARIO_NO_LABORABLE = 'configuracionesReducer/SAVE_CALENDARIO_NO_LABORABLE'


// funciones
export const sagaSetConfiguracionTurnero = (payload) =>({
    type: SAGA_SET_DIAS_ADELANTE_TURNERO,
    payload
})

export const sagaGetCalendariosTurnero = (payload) =>({
    type: SAGA_GET_CALENDARIOS_TURNERO,
    payload
})

export const setCalendariosTurnero = (payload) =>({
    type: SET_CALENDARIOS_TURNERO,
    payload
})

export const sagaEliminarCalendarioHorario = (payload) =>({
    type: SAGA_ELIMINAR_CALENDARIO_HORARIO,
    payload
})

export const sagaSaveCalendarioHorario = (payload) =>({
    type: SAVE_CALENDARIO_HORARIO,
    payload
})

export const sagaEliminarCalendarioNoLaborable = (payload) =>({
    type: SAGA_ELIMINAR_CALENDARIO_NO_LABORABLE,
    payload
})

export const sagaSaveCalendarioNoLaborable = (payload) =>({
    type: SAVE_CALENDARIO_NO_LABORABLE,
    payload
})